import { TranslateService } from '@ngx-translate/core';
import { OrderState, RequestState, ActivityState } from '@iss/libs/graphql';
import { ChangeDetectorRef, Pipe, PipeTransform } from '@angular/core';

import { BaseEnumTranslationPipe } from './base-enum-translation.pipe';

@Pipe({ name: 'orderState', pure: false, standalone: true })
export class OrderStatePipe extends BaseEnumTranslationPipe<OrderState | RequestState | ActivityState> implements PipeTransform{
  protected readonly translationPrefix = 'order-state';

  public constructor(translateService: TranslateService, changeDetectorRef: ChangeDetectorRef) {
    super(translateService, changeDetectorRef);
  }
}
